module.exports = __webpack_public_path__ + "static/img/pc_banner_bg.ea76246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/campusJob/pc_banner_bg.jpg
// module id = 625
// module chunks = 12